import { h, Component, Prop, Host } from '@stencil/core';

@Component({
    shadow: true,
    styleUrl: 'igws-audience-specific.less',
    tag: 'igws-audience-specific',
})
export class AudienceSpecificComponent {
    ids!: string[];
    show: string[] = [];

    /**
     * CMS edit mode
     */
    @Prop() editMode!: boolean;

    /**
     * List of audience ids
     */
    @Prop() items!: string;

    componentWillLoad() {
        this.audiences();
    }

    audiences() {
        this.ids = this.items.split(':');
        const cookies = window.PSC.Cookie.get('aamoptsegs');

        if (cookies) {
            const cookieSplit: string[] = cookies.split('%2C').map((item: string) => item.replace('aam%', ''));

            this.ids.forEach(id => {
                let arr: string[] = [];
                let check = false;
                if (id.includes('&&')) {
                    arr = id.split('&&');
                    check = arr.every(e => cookieSplit.includes(e));
                } else {
                    arr = id.includes(',') ? id.split(',') : [id];
                    check = arr.some(e => cookieSplit.includes(e));
                }
    
                if (check) {
                    this.show.push(id);
                }
            });
        }

        if (this.show.length === 0) {
            this.show.push('default');
        }
    }

    render() {
        if (this.editMode) {
            return (
                <Host>
                    <div class="content">
                        <span class="label">Default</span>
                        <slot name="default" />
                    </div>
                    {this.ids.map(id => 
                        <div class="content">
                            <span class="label">{id}</span>
                            <slot name={id} />
                        </div>
                    )}
                </Host>
            )
        }
        return (
            <Host>
                {this.show.map(id => 
                    <div class="content">
                        <slot name={id} />
                    </div>
                )}
            </Host>
        );
    }
}